export const GITHUB_APP_CLIENT_ID = "3e27d4e7935138a80cd8";
export const GITHUB_APP_CLIENT_SECRET =
  "03aad2d8af499dbcbb047cfb3de4fe06d8e30d89";
export const GITHUB_REPO = "LolipopJ.github.io";
export const GITHUB_REPO_OWNER = "LolipopJ";
export const GITALK_ADMIN = ["LolipopJ"];
